<input
  type="checkbox"
  [name]="option.key"
  [id]="'filter-' + checkboxId"
  (change)="toggleFilter(option)"
  [checked]="option.isActive"
  [disabled]="option.disabled"
/>

<label [for]="'filter-' + checkboxId"> {{ option.key }} ({{ option.count }})</label>
